// Горизонтальный ranked bar-chart для популярности тарифов (Статистика, docs/PLAN.md) — категории
// (тарифы) уже подписаны текстом рядом с каждым баром, поэтому цвет не несёт функцию идентичности
// (dataviz skill: "identity" через цвет нужен, когда категории нужно различать МЕЖДУ марками без
// подписи — здесь подпись есть у каждой) — один sequential-хаб, тот же, что у BarChart.tsx.
const BAR_HEIGHT = 20;
const GAP = 8;

export function RankedBarChart({
  data,
  color = "var(--color-primary)",
}: {
  data: { label: string; value: number }[];
  color?: string;
}) {
  if (data.length === 0) {
    return <p style={{ color: "var(--text-muted)" }}>Нет данных за выбранный период.</p>;
  }

  const max = Math.max(...data.map((d) => d.value), 1);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: GAP }}>
      {data.map((item) => (
        <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 160, fontSize: 13, textAlign: "right", flexShrink: 0 }}>{item.label}</div>
          <div style={{ flex: 1, background: "var(--color-bg-tertiary)", borderRadius: 4 }}>
            <div
              style={{
                width: `${Math.max((item.value / max) * 100, 3)}%`,
                height: BAR_HEIGHT,
                background: color,
                borderRadius: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                paddingRight: 8,
              }}
            >
              <span style={{ color: "var(--color-text-on-primary)", fontSize: 12, fontWeight: 600 }}>
                {item.value}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
